import { createRoute, useParams } from "@tanstack/react-router";
import i18n from "i18next";
import ReservationsGoogleWalletPage from "../pages/reservations-google-wallet";
import { rootRoute } from "./root";

export const langReservationsGoogleWalletRoute = createRoute({
  path: "/$lang/reservations/$hashedId/google-wallet",
  getParentRoute: () => rootRoute,
  loader: () => i18n.loadNamespaces("transfer:google-wallet"),
  component: function RouteComponent() {
    const { hashedId } = useParams({
      from: "/$lang/reservations/$hashedId/google-wallet",
    });
    return <ReservationsGoogleWalletPage hashedId={hashedId} />;
  },
});
